import { dataRecommendSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRecommendSquare = /*#__PURE__*/createIcon(dataRecommendSquare)
export default IconRecommendSquare
